const computeSupportRepartition = (support) => {
    const sumSupport = support.reduce((acc, { proportion }) => (proportion ? acc + proportion : acc), 0);
    const roundedSumSupport = Math.round(sumSupport * 100);

    return roundedSumSupport;
};

export default computeSupportRepartition;
